<template>
  <!-- OH3 エージェント専用 FAB: 右下固定 -->
  <div v-if="showFab" class="agent-fab-container">
    <v-btn
      v-track="'ai-agent-fab'"
      class="agent-fab"
      size="x-large"
      icon
      elevation="8"
      @click="onFabClick"
    >
      <MiniTooltip text="マップAI" :offset-x="0" :offset-y="18">
        <span class="agent-fab-text">マップ<br><small>AI</small></span>
      </MiniTooltip>
    </v-btn>

    <!-- β版イントロダイアログ — FAB クリックのたびに毎回表示 (しつこく) -->
    <v-dialog v-model="showIntro" max-width="480" persistent>
      <v-card>
        <v-card-title class="d-flex align-center">
          <v-icon color="warning" class="mr-2">mdi-flask-outline</v-icon>
          マップAI（β版）について
        </v-card-title>
        <v-card-text style="font-size: 14px; line-height: 1.7;">
          <p>この機能は現在 <b>β版</b> として試験提供しています。</p>
          <ul style="padding-left: 1.2em; margin: 8px 0;">
            <li>仕様の変更や、提供終了の可能性があります</li>
            <li>応答精度・処理速度は改善を続けています</li>
            <li>ご利用に関する重要なお知らせは、OH3トップにて随時ご案内します</li>
          </ul>
          <p style="margin-top: 10px; color: var(--oh3-color-text-secondary, #555);">
            ご意見・ご要望をお寄せいただけると、今後の開発の参考になります。
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="cancelIntro">キャンセル</v-btn>
          <v-btn color="primary" variant="flat" @click="confirmIntro">
            <v-icon start>mdi-compass</v-icon>
            同意して開く
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MiniTooltip from '@/components/MiniTooltip.vue'

const WINDOW_ID = 'ai-agent'

export default {
  name: 'AiAgentFab',
  components: { MiniTooltip },
  data() {
    return {
      showIntro: false,
    }
  },
  computed: {
    ...mapState([
      'isPrint',
      'isIframe'
    ]),
    showFab() {
      // 印刷・iframe 以外は常に表示（小画面でもFABは出す）
      if (this.isPrint || this.isIframe) return false
      return true
    }
  },
  methods: {
    onFabClick() {
      // クリックのたびに毎回イントロを出す (β の注意喚起は常に前置き)
      this.showIntro = true
    },
    confirmIntro() {
      this.showIntro = false
      this.openAgent()
    },
    cancelIntro() {
      this.showIntro = false
    },
    openAgent() {
      const app = this.$root || this.$store.state.oh3App || window.vueApp
      app?.usageTracker?.trackEvent('ai-agent-fab', 'click', 'open', { text: 'マップAI' })
      this.$store.commit('setFloatingVisible', { id: WINDOW_ID, visible: true })
    }
  }
}
</script>

<style scoped>
.agent-fab-container {
  position: fixed;
  bottom: 234px;     /* 元の MlitSearchFab と同位置 */
  right: 20px;
  z-index: 1002;
}

.agent-fab {
  width: 64px !important;
  height: 64px !important;
  border-radius: var(--oh3-radius-full) !important;
  /* OH3 マップAI 紺青（フラット） */
  background: rgb(60, 80, 120) !important;
  color: white !important;
  box-shadow:
    0 6px 20px rgba(60, 80, 120, 0.45),
    0 3px 10px var(--oh3-color-overlay-20) !important;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
}

.agent-fab:hover {
  transform: scale(1.1) !important;
  box-shadow:
    0 8px 25px rgba(60, 80, 120, 0.55),
    0 4px 15px var(--oh3-color-overlay-30) !important;
}

.agent-fab:active {
  transform: scale(0.95) !important;
}

.agent-fab-text {
  font-size: var(--oh3-font-size-base);
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 1.2;
  text-align: center;
}

.agent-fab-text small {
  font-size: var(--oh3-font-size-xs);
  font-weight: 600;
  letter-spacing: 0.5px;
  opacity: 0.9;
  display: block;
  margin-top: 2px;
}

/* モバイル対応 */
@media (max-width: 500px) {
  .agent-fab-container {
    bottom: 210px;
    right: 16px;
  }

  .agent-fab {
    width: 56px !important;
    height: 56px !important;
  }

  .agent-fab-text {
    font-size: var(--oh3-font-size-sm);
  }
}

/* 印刷時は非表示 */
@media print {
  .agent-fab-container {
    display: none !important;
  }
}
</style>
